import { jsx } from '@emotion/react';
import React, { useState, useRef, useEffect, Children } from 'react';
import { ActiveIndicator, Indicator, TabsContainer, StyledTabs, StyledContent, TabContent } from './styles';
import NavTabs from './NavTabs';
import { handleActiveIndicator, renderActiveTabContent, renderChildrenWithTabs, handleAriaMove, handleKeyPress } from './util';
export const renderSeoFriendlyTabs = (props, activeTabIndex) => {
  const children = props.children;
  return Children.map(children, (child, i) => jsx(TabContent, {
    active: activeTabIndex === i
  }, child.props.children));
};
const DefaultTabs = props => {
  const tabsRef = useRef(null);
  const indicatorRef = useRef(null);
  const {
    isNarrow,
    isNarrowBreakpoint,
    isDivider,
    isInverse,
    isSeoFriendly,
    dynamicTabIndex = 0,
    showActiveIndicator = true,
    contentMinHeight,
    contentPaddingTop = '',
    customMarginRight = '',
    numOfEvenWidthMobile = '',
    onTabSelected: _onTabSelected,
    ariaLabel,
    enableTabsAccessibility = false,
    ...rest
  } = props;
  const [activeTabIndex, setTabIndex] = useState(props.activeTabIndex || 0);
  const [activeAriaFocusIndex, setAriaFocusIndex] = useState(props.activeTabIndex || props.dynamicTabIndex || 0);
  const [keyPressed, setKeyPress] = useState(false);
  useEffect(() => {
    handleActiveIndicator(tabsRef, indicatorRef, activeTabIndex);
  }, [activeTabIndex]);
  useEffect(() => {
    setTabIndex(dynamicTabIndex);
  }, [dynamicTabIndex]);
  useEffect(() => {
    keyPressed && handleAriaMove(tabsRef, activeAriaFocusIndex, keyPressed);
  }, [activeAriaFocusIndex]);
  return jsx(React.Fragment, null, jsx(TabsContainer, rest, jsx(StyledTabs, {
    isNarrow: isNarrow,
    isNarrowBreakpoint: isNarrowBreakpoint,
    isInverse: isInverse,
    ref: tabsRef,
    role: 'tablist',
    "aria-label": ariaLabel,
    onKeyDown: enableTabsAccessibility ? event => handleKeyPress(event, props, activeAriaFocusIndex, activeTabIndex, setAriaFocusIndex, setKeyPress) : undefined,
    customMarginRight: customMarginRight,
    numOfEvenWidthMobile: numOfEvenWidthMobile
  }, renderChildrenWithTabs(props, activeTabIndex, setTabIndex, setAriaFocusIndex), showActiveIndicator && jsx(ActiveIndicator, {
    isInverse: isInverse,
    ref: indicatorRef
  })), !isDivider && jsx(Indicator, {
    isInverse: isInverse
  })), jsx(StyledContent, {
    minHeight: contentMinHeight,
    contentPaddingTop: contentPaddingTop
  }, isSeoFriendly ? renderSeoFriendlyTabs(props, activeTabIndex) : renderActiveTabContent(props, activeTabIndex)));
};
const Tabs = _ref => {
  let {
    isNarrowBreakpoint = 'max',
    activeTabIndex = 0,
    showActiveIndicator = true,
    enableNavigation,
    ...rest
  } = _ref;
  const navProps = {
    isNarrowBreakpoint,
    activeTabIndex,
    showActiveIndicator,
    ...rest
  };
  return enableNavigation ? jsx(NavTabs, navProps) : jsx(DefaultTabs, navProps);
};
Tabs.displayName = 'Tabs';
export default Tabs;
//# sourceMappingURL=index.js.map